if (window.location.pathname === '/pages/member-directory') {
  document.documentElement.hidden = true;
  window.location.replace('/');
}

class CfsaDeferredVideo extends HTMLElement {
  connectedCallback() {
    this.video = this.querySelector('video');
    this.poster = this.querySelector('[data-video-poster]');

    if (!this.video || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    this.loadWhenVisible = this.loadWhenVisible.bind(this);
    this.observer = new IntersectionObserver(this.loadWhenVisible, { rootMargin: '300px 0px' });
    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }

  loadWhenVisible(entries) {
    if (!entries.some((entry) => entry.isIntersecting)) return;

    this.observer?.disconnect();
    const load = () => {
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(() => this.loadVideo(), { timeout: 1500 });
      } else {
        window.setTimeout(() => this.loadVideo(), 1);
      }
    };

    if (document.readyState === 'complete') {
      load();
    } else {
      window.addEventListener('load', load, { once: true });
    }
  }

  loadVideo() {
    if (this.dataset.loaded === 'true') return;

    const sources = this.video.querySelectorAll('source[data-src]');
    for (const source of sources) {
      source.src = source.dataset.src;
      source.removeAttribute('data-src');
    }

    if (!sources.length && this.video.dataset.src) {
      this.video.src = this.video.dataset.src;
      this.video.removeAttribute('data-src');
    }

    this.dataset.loaded = 'true';
    this.video.load();
    this.video.addEventListener(
      'loadeddata',
      async () => {
        this.classList.add('is-video-ready');
        if (this.dataset.autoplay !== 'true') return;

        try {
          await this.video.play();
        } catch {
          this.video.controls = true;
        }
      },
      { once: true },
    );
  }
}

if (!customElements.get('cfsa-deferred-video')) {
  customElements.define('cfsa-deferred-video', CfsaDeferredVideo);
}
